import { render, staticRenderFns } from "./newestProduct.vue?vue&type=template&id=1a1d4391&scoped=true&"
import script from "./newestProduct.vue?vue&type=script&lang=js&"
export * from "./newestProduct.vue?vue&type=script&lang=js&"
import style0 from "./newestProduct.vue?vue&type=style&index=0&id=1a1d4391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d4391",
  null
  
)

export default component.exports